import { jsx as a } from "react/jsx-runtime";
import l from "clsx";
import '../../assets/vertical-rhythm.css';const r = {
  "vertical-rhythm": "_vertical-rhythm_mdrr3_1",
  "vertical-rhythm--vertical-padding-xs": "_vertical-rhythm--vertical-padding-xs_mdrr3_5",
  "vertical-rhythm--vertical-padding-sm": "_vertical-rhythm--vertical-padding-sm_mdrr3_9",
  "vertical-rhythm--vertical-padding-md": "_vertical-rhythm--vertical-padding-md_mdrr3_13",
  "vertical-rhythm--vertical-padding-lg": "_vertical-rhythm--vertical-padding-lg_mdrr3_17",
  "vertical-rhythm--vertical-padding-xl": "_vertical-rhythm--vertical-padding-xl_mdrr3_21",
  "vertical-rhythm--vertical-padding-2xl": "_vertical-rhythm--vertical-padding-2xl_mdrr3_25",
  "vertical-rhythm__inner": "_vertical-rhythm__inner_mdrr3_29",
  "vertical-rhythm__inner--gap-xs": "_vertical-rhythm__inner--gap-xs_mdrr3_34",
  "vertical-rhythm__inner--gap-sm": "_vertical-rhythm__inner--gap-sm_mdrr3_38",
  "vertical-rhythm__inner--gap-md": "_vertical-rhythm__inner--gap-md_mdrr3_42",
  "vertical-rhythm__inner--gap-lg": "_vertical-rhythm__inner--gap-lg_mdrr3_46",
  "vertical-rhythm__inner--gap-xl": "_vertical-rhythm__inner--gap-xl_mdrr3_50",
  "vertical-rhythm__inner--gap-2xl": "_vertical-rhythm__inner--gap-2xl_mdrr3_54"
}, e = ({
  verticalRhythm: i = "md",
  spaceBetween: t = "md",
  children: _
}) => /* @__PURE__ */ a(
  "div",
  {
    "data-testid": "vertical-rhythm",
    className: l({
      [r["vertical-rhythm"]]: !0,
      [r["vertical-rhythm--vertical-padding-xs"]]: i === "xs",
      [r["vertical-rhythm--vertical-padding-sm"]]: i === "sm",
      [r["vertical-rhythm--vertical-padding-md"]]: i === "md",
      [r["vertical-rhythm--vertical-padding-lg"]]: i === "lg",
      [r["vertical-rhythm--vertical-padding-xl"]]: i === "xl",
      [r["vertical-rhythm--vertical-padding-2xl"]]: i === "2xl"
    }),
    children: /* @__PURE__ */ a(
      "div",
      {
        className: l({
          [r["vertical-rhythm__inner"]]: !0,
          [r["vertical-rhythm__inner--gap-xs"]]: t === "xs",
          [r["vertical-rhythm__inner--gap-sm"]]: t === "sm",
          [r["vertical-rhythm__inner--gap-md"]]: t === "md",
          [r["vertical-rhythm__inner--gap-lg"]]: t === "lg",
          [r["vertical-rhythm__inner--gap-xl"]]: t === "xl",
          [r["vertical-rhythm__inner--gap-2xl"]]: t === "2xl"
        }),
        children: _
      }
    )
  }
);
export {
  e as VerticalRhythm
};
